import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { LOGIN_API } from "./apiRoutes";

const mutateLogin = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(LOGIN_API, data);
};

const useLoginMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateLogin,
    ...queryParams,
  });

export default useLoginMutation;
